import {connect} from "react-redux";
import Nav from "../../components/Nav/Nav.js";
import {handleOpenNavItem} from "../../actions/setNavLink";


const MapStateToProps = (state) => ({
navItem: state.navLink.navItem,
dataUser: state.user.dataUser
});

const MapDispatchToProps = (dispatch) => ({
handleOpenNavItem: (string) => {
dispatch(handleOpenNavItem(string));
}
});

export default connect(MapStateToProps, MapDispatchToProps)(Nav);